export enum RightnavState {
    Emergency = 'Emergency',
    Help = 'Help',
    Notifications = 'Notifications'
}
